<template>
  <el-form ref="form">
    <el-row>
      <el-col :span="16"
              :offset="4">
        <h2>Mail</h2>
        <el-form-item label="From">
          <el-select v-model="selectedMail"
                     placeholder="Please choose">
            <el-option v-for="item in options"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Mail To">
          <user-picklist v-on:updateSelectAuthor="updateSelectAuthor"
                         :bus="bus"></user-picklist>
        </el-form-item>
        <el-form-item label="Subject">
          <el-input v-model="subject"></el-input>
        </el-form-item>
        <hr style="border: 1px solid #ebeef5">
        <text-editor v-on:updateMailContent="updateMailContent"
                     :bus="bus" style="height:150px"></text-editor>
        <div style="clear:both;height:80px"></div>
        <el-form-item>
          <attachement v-on:updateFiles="updateFiles"
                       :bus="bus"></attachement>
        </el-form-item>
        <el-form-item>
          <el-button :loading="uploading"
                     @click="handleSubmit"
                     type="primary">Send</el-button>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
import Vue from 'vue';
import Attachement from './Attachement';
import UserPicklist from './UserPicklist';
import TextEditor from './TextEditor';
export default {
  components: {
    Attachement,
    UserPicklist,
    TextEditor,
  },
  data() {
    return {
      bus: new Vue(),
      authorsID: [],
      subject: '',
      content: '',
      files: new FormData(),
      selectedMail: '',
      options: [
        {
          value: 'BEP',
          label: 'BEP - finance@businessexpertpress.com',
        },
        // {
        //   value: 'BEP',
        //   label: 'BEP - charlene.kronstedt@businessexpertpress.com',
        // },
        // {
        //   value: 'BEP',
        //   label: 'BEP - melissa.yeager@businessexpertpress.com',
        // },
        // {
        //   value: 'BEP',
        //   label: 'BEP - sheri.dean@businessexpertpress.com',
        // },
        // {
        //   value: 'BEP',
        //   label: 'BEP - katie.fuller@businessexpertpress.com',
        // },
        // {
        //   value: 'BEP',
        //   label: 'BEP - nancy.burds@businessexpertpress.com',
        // },
        // {
        //   value: 'BEP',
        //   label: 'BEP - scott.isenberg@businessexpertpress.com',
        // },
        // {
        //   value: 'BEP',
        //   label: 'BEP - rob.zwettler@businessexpertpress.com',
        // },
        // {
        //   value: 'BEP',
        //   label: 'BEP - stinnie@businessexpertpress.com',
        // },
        {
          value: 'MP',
          label: 'MP - finance@momentumpress.net',
        },
        // {
        //   value: 'MP',
        //   label: 'MP - joel@momentumpress.net',
        // },
      ],
      uploading: false,
    };
  },
  methods: {
    updateFiles(formData) {
      this.files = formData;
    },
    updateSelectAuthor(authorsID) {
      this.authorsID = authorsID;
    },
    updateMailContent(content) {
      this.content = content;
    },
    handleSubmit() {
      this.uploading = true;
      this.uploadFiles()
        .then(result => {
          if (result) {
            return this.sendEmail();
          } else {
            this.$message({
              message: `Server error.`,
              type: 'error',
            });
          }
        })
        .then(() => {
          this.uploading = false;
          this.resetData();
        })
        .catch(err => {
          this.uploading = false;
        });
    },
    uploadFiles() {
      return new Promise((resolve, reject) => {
        if (this.authorsID.length === 0) {
          this.$message({
            message: `You didn't choose any user.`,
            type: 'error',
          });
          return reject(false);
        } else {
          this.files.append('users', JSON.stringify(this.authorsID));
          this.axios({
            method: 'post',
            url: `file/multi-users`,
            data: this.files,
          })
            .then(res => {
              return resolve(res.status === 200);
            })
            .catch(err => reject(err));
        }
      });
    },
    sendEmail() {
      return new Promise((resolve, reject) => {
        if (this.authorsID.length === 0) {
          this.$message({
            message: `You didn't choose any author.`,
            type: 'error',
          });
          return reject(false);
        } else {
          this.axios({
            method: 'post',
            url: 'mail',
            data: {
              selectedMail: this.selectedMail,
              userIDs: this.authorsID,
              subject: this.subject,
              content: this.content,
              files: this.getFilenameList(),
            },
          })
            .then(res => {
              this.$message({
                message: 'Send Success',
                type: 'success',
              });
              return resolve(true);
            })
            .catch(err => {
              return reject(err);
            });
        }
      });
    },
    getFilenameList() {
      let filenameList = [];
      for (const value of this.files.values()) {
        if (value.name) filenameList.push(value.name);
      }
      return filenameList;
    },
    countFile() {
      var i = 0;
      for (var value of this.files.values()) {
        i++;
      }
      return i;
    },
    resetData() {
      this.authorsID = [];
      this.subject = '';
      this.content = '';
      this.bus.$emit('clearData');
    },
  },
};
</script>

<style lang="scss" scoped>
.el-select {
  width: 100%;
}
</style>




// WEBPACK FOOTER //
// src/components/admin/mail/Index.vue